import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import About from './components/About'
import Services from './components/Services'
import Portfolio from './components/Portfolio'
// import Gallery from './components/Gallery'
import Team from './components/Team'
import Clients from './components/Clients'
import Contact from './components/Contact'
import Footer from './components/Footer'
import Logo from './img/Logo.png';

import { FaLinkedin, FaTwitter, FaEnvelope } from 'react-icons/fa'

function App() {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Simulate loading time
    setTimeout(() => {
      setIsLoading(false)
    }, 1500)
  }, [])

 if (isLoading) {
  return (
    <div className="h-screen w-screen flex flex-col items-center justify-center gap-4 bg-[--jtg-navy]">
      <motion.img
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        src={Logo}
        alt="JTG Enterprises Logo"
        className="w-20 h-20 object-contain rounded-full shadow-lg"
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="text-4xl font-playfair text-[--jtg-blue] tracking-tight"
      >
        JTG Enterprises Limited
      </motion.div>
    </div>
  )
}

  return (
    <div className="min-h-screen bg-glassy-gradient">
      <Navbar />
      <main className="flex flex-col gap-0">
        <Hero />
        <About />
        <Services />
        <Portfolio />
        {/* <Gallery /> */}
        <Team />
        <Clients />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}

export default App 